import { v } from 'convex/values'

export const planTermValidator = v.union(
  v.literal('month'),
  v.literal('year'),
  v.literal('lifetime'),
)
export type PlanTerm = 'month' | 'year' | 'lifetime'
